import React from "react";
import PropTypes from "prop-types";
import "./styles.scss";


const AcceptPapModal = ({
	setShowAcceptPapModal,
	showAcceptPapModal,
	acceptPap,
	getCases,
	idCase,
	changeStatus
}) => {

	const handleModal = () => {
		// Ouvre/ferme la modal
		showAcceptPapModal ? setShowAcceptPapModal(false) : null;
	};

	const handleAcceptation = () => {
		// change le status dans l'état local
		changeStatus(5, idCase);
		// refresh les cas
		getCases();
		// update du status en BDD sur 5 (= accepter)
		acceptPap();
		// ferme la modal
		setShowAcceptPapModal(false);
	};

	return (
		<>
			<div className="content">
				<p className="title">Confirmation</p>
				<div className="container-modal">
					<p className="subtitle">Acceptez-vous ce plan d&apos;aide personnalisé ?</p>
				</div>
				<div className="containerButton">
					<button className="buttonModalPap orange" onClick={handleAcceptation}>Oui, je confirme</button>
					<button className="buttonModalPap white" onClick={handleModal}>Annuler</button>
				</div>
			</div>
			<div className="modalBackground" onClick={handleModal}></div>
		</>
	);
};

AcceptPapModal.propTypes = {
	setShowAcceptPapModal: PropTypes.func,
	showAcceptPapModal: PropTypes.bool,
	acceptPap: PropTypes.func,
	changeStatus: PropTypes.func,
	getCases: PropTypes.func,
	idCase: PropTypes.string,
};

export default AcceptPapModal;
